import React, { useState } from 'react';

const WHATSAPP_NUMBER = '+27832391619'; 

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=Hello!%20I'd%20like%20to%20know%20more%20about%20your%20sweets%20and%20snacks.`;

  return (
    <div className="whatsapp-wrapper">
      {isOpen && (
        <div className="whatsapp-popup">
          <div className="whatsapp-popup-header">
            <span className="whatsapp-avatar">🍬</span>
            <div className="whatsapp-header-text">
              <p className="whatsapp-name">Sweet &amp; Snack World</p>
              <p className="whatsapp-status">Typically replies instantly</p>
            </div>
            <button className="whatsapp-close" onClick={() => setIsOpen(false)} aria-label="Close">✕</button>
          </div>
          <div className="whatsapp-popup-body">
            <div className="whatsapp-bubble">
              👋 Hi there! How can we help you today? Drop us a message and we'll get back to you right away!
            </div>
          </div>
          <div className="whatsapp-popup-footer">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-start-btn"
            >
              <svg viewBox="0 0 32 32" width="18" height="18" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                <path d="M16 0C7.163 0 0 7.163 0 16c0 2.816.734 5.461 2.018 7.762L0 32l8.472-2.018C10.724 31.287 13.307 32 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm8.278 22.556c-.344.966-1.702 1.765-2.797 1.998-.744.158-1.715.285-4.984-.957-4.19-1.563-6.89-5.82-7.1-6.09-.202-.27-1.7-2.264-1.7-4.317s1.063-3.053 1.46-3.461c.384-.394.837-.494 1.117-.494.277 0 .554.003.797.014.255.012.598-.097.937.717.344.826 1.17 2.878 1.271 3.083.101.201.168.437.033.703-.134.27-.2.437-.394.672-.197.235-.414.524-.59.703-.198.198-.403.413-.174.81.23.394 1.02 1.683 2.19 2.726 1.505 1.342 2.773 1.76 3.17 1.961.395.2.625.168.857-.1.235-.27 1.002-1.169 1.27-1.566.265-.394.53-.33.893-.197.365.134 2.32 1.094 2.715 1.292.396.198.659.3.757.463.1.163.1.944-.244 1.91z" fill="white"/>
              </svg>
              Start Chat
            </a>
          </div>
        </div>
      )}

      <button
        className={`whatsapp-fab${isOpen ? ' open' : ''}`}
        onClick={() => setIsOpen(prev => !prev)}
        aria-label="Chat on WhatsApp"
      >
        {isOpen ? (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 005.7 7.11L10.59 12 5.7 16.89a1 1 0 001.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 32 32" width="28" height="28" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.816.734 5.461 2.018 7.762L0 32l8.472-2.018C10.724 31.287 13.307 32 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm8.278 22.556c-.344.966-1.702 1.765-2.797 1.998-.744.158-1.715.285-4.984-.957-4.19-1.563-6.89-5.82-7.1-6.09-.202-.27-1.7-2.264-1.7-4.317s1.063-3.053 1.46-3.461c.384-.394.837-.494 1.117-.494.277 0 .554.003.797.014.255.012.598-.097.937.717.344.826 1.17 2.878 1.271 3.083.101.201.168.437.033.703-.134.27-.2.437-.394.672-.197.235-.414.524-.59.703-.198.198-.403.413-.174.81.23.394 1.02 1.683 2.19 2.726 1.505 1.342 2.773 1.76 3.17 1.961.395.2.625.168.857-.1.235-.27 1.002-1.169 1.27-1.566.265-.394.53-.33.893-.197.365.134 2.32 1.094 2.715 1.292.396.198.659.3.757.463.1.163.1.944-.244 1.91z" fill="white"/>
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppButton;
